import './response-loading-screen.css'

const ResponseLoadingScreen = (props) => {
        if(props.loading === true){
            return(
                <div className="new-teacher-loading-screen-wrapper ">
                    <div className="new-teacher-loading-screen">
                        <div className="new-teacher-loading-screen_header loading-for-response-text">
                            <img className='new-teacher-loading-screen_chatgpt-logo' src="https://pngimg.com/d/chatgpt_PNG2.png" alt="Loading..." />
                            <p>+</p>
                            <img className="new-teacher-loading-screen_atharo-logo" src="https://www.atharomusic.com/atharo-music.png" alt="Atharo Logo" />
                        </div>
                        <h5 className="new-teacher-loading-text">Working with ChatGPT to create SEO friendly content. Creating {Math.round(props.numberOfInstruments * 3)} pages, this should take <strong>{Math.round(props.numberOfInstruments * 3 / 2)} minutes</strong>.</h5>
                        <div className="new-teacher-loading-screen__warning"><p>Do NOT close tab!</p></div>
                            
                    </div>
                </div>
            )
        }else {
            return null
        }
}
export default ResponseLoadingScreen